/**
 * HTML 문자열에서 태그 내부는 건드리지 않고, 텍스트 노드만 <mark>로 래핑
 * - 검색어가 없으면 원본 반환
 * - 정규식 특수문자 이스케이프 처리
 */
export function highlightHTMLText(html: string, query: string): string {
  if (!query || !html) return html;

  const trimmed = query.trim();
  if (!trimmed) return html;

  // 정규식 특수문자 이스케이프
  const escaped = trimmed.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  // HTML을 태그와 텍스트로 분리
  // /<[^>]*>/ 는 HTML 태그 매칭, 나머지는 텍스트 노드
  const tagPattern = /(<[^>]*>)/g;
  const parts = html.split(tagPattern);

  const highlighted = parts.map((part) => {
    // HTML 태그이면 그대로 유지
    if (part.startsWith('<')) return part;

    // 텍스트 노드: 검색어를 <mark>로 래핑
    return part.replace(
      new RegExp(`(${escaped})`, 'gi'),
      '<mark class="search-highlight">$1</mark>',
    );
  });

  return highlighted.join('');
}
